import React, { useEffect, useMemo, useState } from "react";
import { Input, Label } from "reactstrap";

/**
 * Compact preset duration filter used across admin lists/dashboards.
 * Uses a single dropdown for presets + optional From/To when Custom is selected.
 */
export default function DurationFilter({
  duration,
  setDuration,
  customRange,
  setCustomRange,
  label = "Range",
  options,
}) {
  const [showCustom, setShowCustom] = useState(duration === "custom");

  useEffect(() => {
    setShowCustom(duration === "custom");
  }, [duration]);

  const opts = useMemo(
    () =>
      options || [
        { value: "today", label: "Today" },
        { value: "yesterday", label: "Yesterday" },
        { value: "7d", label: "Last 7 days" },
        { value: "month", label: "This month" },
        { value: "6month", label: "Last 6 months" },
        { value: "custom", label: "Custom" },
      ],
    [options]
  );

  return (
    <div className="duration-filter w-100" style={{ minWidth: 0 }}>
      <div className="row g-2 g-sm-3 align-items-end">
        {/* Full width of parent — avoids truncated select text when nested in narrow columns */}
        <div className="col-12">
          <Label className="small text-muted fw-bold mb-1 d-block">{label}</Label>
          <Input
            type="select"
            bsSize="sm"
            className="w-100"
            style={{ maxWidth: "100%" }}
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          >
            {opts.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Input>
        </div>

        {showCustom ? (
          <>
            <div className="col-12 col-sm-6">
              <Label className="small text-muted fw-bold mb-1 d-block">From</Label>
              <Input
                type="date"
                bsSize="sm"
                className="w-100"
                value={customRange?.from || ""}
                onChange={(e) => setCustomRange({ ...(customRange || {}), from: e.target.value })}
              />
            </div>
            <div className="col-12 col-sm-6">
              <Label className="small text-muted fw-bold mb-1 d-block">To</Label>
              <Input
                type="date"
                bsSize="sm"
                className="w-100"
                value={customRange?.to || ""}
                onChange={(e) => setCustomRange({ ...(customRange || {}), to: e.target.value })}
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
